// services/auth.service.ts
import { Injectable, inject, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap, of, catchError, throwError } from 'rxjs';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface AuthResponse {
  access: string;
  refresh?: string;
  expiresIn?: number;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient);
 
  private readonly TOKEN_KEY = 'access_token';
  private readonly REFRESH_KEY = 'refresh_token';
  private readonly API_URL = '/api/auth';

  private tokenSignal = signal<string | null>(this.getTokenFromStorage());
  public token = this.tokenSignal.asReadonly();
  
  public isAuthenticated = computed(() => !!this.tokenSignal());

  // login(credentials: LoginCredentials): Observable<AuthResponse> {
  //   return this.http.post<AuthResponse>(`${this.API_URL}/login`, credentials).pipe(
  //     tap(response => this.setSession(response))
  //   );
  // }

  guardarTokens( tokens: AuthResponse): void {
    
      this.setSession(tokens);
      this.tokenSignal.set(tokens.access);
  }
    
  
  refreshToken(): Observable<AuthResponse | boolean> {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) {
      return of(false); //throwError(() => new Error('No refresh token'));
    }

    return this.http.post<AuthResponse>(`${this.API_URL}/refresh`, { refreshToken }).pipe(
      tap(response => this.updateToken(response))
    );
  }

  logout(): void {
    this.clearSession();
    // this.router.navigate(['/login']);
  }

  getToken(): string | null {
    return this.tokenSignal();
  }

  getAuthorizationHeader(): string | null {
    const token = this.tokenSignal();
    return token ? `Bearer ${token}` : null;
  }

  private setSession(authResult: AuthResponse): void {
    localStorage.setItem(this.TOKEN_KEY, authResult.access);
    if (authResult.refresh) {
      localStorage.setItem(this.REFRESH_KEY, authResult.refresh);
    }
    if (authResult.expiresIn) {
      const expiresAt = Date.now() + authResult.expiresIn * 1000;
      localStorage.setItem('expires_at', expiresAt.toString());
    }
    this.tokenSignal.set(authResult.access);
  }

  private updateToken(authResult: AuthResponse): void {
    localStorage.setItem(this.TOKEN_KEY, authResult.access);
    if (authResult.refresh) {
      localStorage.setItem(this.REFRESH_KEY, authResult.refresh);
    }
    this.tokenSignal.set(authResult.access);
  }

  private clearSession(): void {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.REFRESH_KEY);
    localStorage.removeItem('expires_at');
    this.tokenSignal.set(null);
  }

  private getTokenFromStorage(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  private getRefreshToken(): string | null {
    return localStorage.getItem(this.REFRESH_KEY);
  }

  isTokenExpired(): boolean {
    const expiresAt = localStorage.getItem('expires_at');
    if (!expiresAt) return true;
    return Date.now() > parseInt(expiresAt);
  }

  getCustomerIdFromToken(): number | null {
    const token = this.tokenSignal();
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.id || payload.userId || (payload.sub ? parseInt(payload.sub) : null) || null;
    } catch (e) {
      console.error('Error al decodificar token', e);
      return null;
    }
  }

}
